import { campaignColors } from '@prisjakt/ui-base';

const getCampaignColor = (campaignId, colorVariant) => {
  const matchedKey = Object.keys(campaignColors).find(
    key => campaignColors[key] && campaignColors[key].id === campaignId
  );

  if (!matchedKey) {
    return null;
  }

  return campaignColors[matchedKey][colorVariant] || null;
};

export default getCampaignColor;
